{
  "instances": {
    "jolokia": {
      "label": "JMX",
      "close": "Close",
      "domains": "Domains",
      "execute": "Execute",
      "executing": "Executing...",
      "execute_modal_header": "Execute <code>{name}</code>?",
      "execution_failed": "Execution failed.",
      "execution_successful": "Execution successful.",
      "mbeans": "MBeans"
    }
  }
}
